import React, { FC } from "react";
import styled from "../../../theme";
import InfoIcon from '../../../assets/icons/InfoGrey.svg';

const MoreDetails = styled.button<{ $isInline?: boolean }>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: ${(props) => (props.$isInline ? '24px' : '28px')};
    height: ${(props) => (props.$isInline ? '24px' : '28px')};
    color: #3b87a0;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    outline: none;
    border: none;
    background: transparent;
    padding: 0;
    border-radius: 6px;
    margin-left: ${(props) => (props.$isInline ? '0' : 'auto')};
    transition: background-color 0.15s ease;

    &:hover {
        background-color: #eef2f6;
    }

    &:hover svg path {
        stroke: #334155;
    }
`;

const Content = styled.span<{ $isInline?: boolean }>`
    display: inline-flex;
    align-items: center;

    svg {
        width: ${(props) => (props.$isInline ? '16px' : '18px')};
        height: ${(props) => (props.$isInline ? '16px' : '18px')};
        transition: stroke 0.15s ease;
    }
`;

export interface MoreDetailsButtonProps {
    isDetailsDisplayed: boolean;
    isInline?: boolean;
    onToggleClientDetails(): void;
}

const MoreDetailsButton: FC<MoreDetailsButtonProps> = (props) => (
    <MoreDetails onClick={props.onToggleClientDetails} $isInline={props.isInline}>
        <Content $isInline={props.isInline}>
            <InfoIcon/>
        </Content>
    </MoreDetails>
);

export default MoreDetailsButton;
